export default {
  FETCH_CAREER_TITLES_START: 'FETCH_CAREER_TITLES_START',
  FETCH_CAREER_TITLES_SUCCESS: 'FETCH_CAREER_TITLES_SUCCESS',
  FETCH_CAREER_TITLES_FAILURE: 'FETCH_CAREER_TITLES_FAILURE',
}
